import React from 'react';
import { usePortaledTooltip } from './hooks/usePortaledTooltip';

/**
 * Inline citation for agent responses. Renders the display label with a dotted
 * underline; hovering (or focusing) reveals a portaled tooltip with the cited
 * item ID. Portals to document.body so the tooltip is not clipped by the
 * scrollable message list, and clamps to the viewport so citations near the
 * right edge or top do not overflow.
 *
 * @param {{
 *   type: 'workplan' | 'ridd',
 *   itemId: string,
 *   children: React.ReactNode,
 * }} props
 */
export default function AiChatCitation({ type, itemId, children }) {
  const {
    tooltipId,
    triggerRef,
    open,
    scheduleShow,
    scheduleHide,
    renderPopper,
  } = usePortaledTooltip({ placement: 'auto', clampToViewport: true });

  return (
    <>
      <span
        ref={triggerRef}
        className="ddv-ai-chat__citation"
        data-citation-type={type}
        tabIndex={0}
        aria-label={`Citation ${itemId}`}
        aria-describedby={open ? tooltipId : undefined}
        onMouseEnter={scheduleShow}
        onMouseLeave={scheduleHide}
        onFocus={scheduleShow}
        onBlur={scheduleHide}
      >
        {children}
      </span>
      {renderPopper(itemId)}
    </>
  );
}
